/* Установщик каркаса: бывший встроенный скрипт app.html. Разметка уже стоит в документе, модули разделов — в window. */
import { createShell } from './engine';
import { installTts } from '../tts/module';

export function installShell() {
  installTts();
  createShell();
}
